import CampaignAssignListPanel from "./campaignAssignListPanel.container"

export default CampaignAssignListPanel
